import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '7px 0px',
    '& .tbody': {
      '& .table-row': {
        height: '36px !important'
      }
    }
  }
}))

export default useStyles
